<template>
  <v-app>
    <MainComponent :user="user"></MainComponent>
  </v-app>
</template>

<script>
import MainComponent from "./components/MainComponent.vue"

export default {
  name: 'App',

  components: {
    MainComponent
  },
  created: function(){
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('name') || 'You';
    this.user = myParam;
  },
  data: () => ({
    user:'You'
  }),
};
</script>
<style>
.moduleWrapper {
  overflow: inherit !important;
}
.module {
  overflow: unset !important;
}
html, body{
  overflow-y: hidden;
}
body{
  background-color: #fdf6ec;
  background-size: cover;
}
.v-application{
  background: transparent !important;
}
</style>